export default __webpack_public_path__ + "static/media/bank.040856f0.svg";